export default __webpack_public_path__ + "static/media/f02.ae5928b0.svg";